import { Locality } from "../../cmodel/cmodel.repo";

export class TradeValidity {
  public security: string;
  public isin: string;
  public locality: Locality;
  public portfolios: string[];

  public price: number;
  public indicativePrice: number;
  public validTill: Date;
  public ticker: string;

  public useCase : string;

  constructor(tradeSecurity) {
    this.security = tradeSecurity.security;
    this.isin = tradeSecurity.isin;
    this.locality = tradeSecurity.locality;
    this.portfolios = tradeSecurity.portfolios;
    this.indicativePrice = tradeSecurity.lastPrice || tradeSecurity.indicativePrice;
    this.useCase = tradeSecurity.useCase
  }
}



// WEBPACK FOOTER //
// ./src/app/trading/models/TradeValidity.ts